import { Moon, Sun } from 'lucide-react';

import { useTheme } from '../providers/theme-provider';
import { IconButton } from './ui/topbar-surface';

export function ThemeToggle() {
  const { resolvedTheme, toggleTheme } = useTheme();

  return (
    <IconButton
      icon={resolvedTheme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
      label="Toggle theme"
      onClick={toggleTheme}
    />
  );
}
